// Session-scoped on purpose: closing an auto-opened panel is a "not now", not a permanent opt-out.
export const SUPPORT_AI_AUTO_OPEN_SUPPRESSED_KEY = '__qc_support_ai_autoopen_suppressed';

export const isSupportAiAutoOpenSuppressed = (): boolean => {
  try {
    return sessionStorage.getItem(SUPPORT_AI_AUTO_OPEN_SUPPRESSED_KEY) === '1';
  } catch {
    return false;
  }
};

export const suppressSupportAiAutoOpen = () => {
  try {
    sessionStorage.setItem(SUPPORT_AI_AUTO_OPEN_SUPPRESSED_KEY, '1');
  } catch {
    // Private-mode sessionStorage throws; in-memory state still holds for this page load.
  }
};

export const clearSupportAiAutoOpenSuppression = () => {
  try {
    sessionStorage.removeItem(SUPPORT_AI_AUTO_OPEN_SUPPRESSED_KEY);
  } catch {
    // See above.
  }
};
